{
  "deleteProrationTitle": "Delete Proration",
  "deleteProrationMessage": "Are you sure you want to delete this proration?",
  "requiredField": "Required Field",
  "title": "Orders",
  "overview": "Overview",
  "order-flow": "Order Flow",
  "messages": "Messages",
  "documents": "Documents",
  "notes": "Notes",
  "parties": "Parties",
  "order": "Order",
  "properties": "Properties",
  "loans": "Loans",
  "payoffs": "Payoffs",
  "loan-amount": "Loan Amount",
  "property": "Property",
  "status": "Status",
  "loan-number": "Loan Number",
  "active": "Active",
  "all-orders": "All Orders",
  "in-progress": "In Progress",
  "on-hold": "On Hold",
  "create-order": "Create New Order",
  "active-orders": "Active Orders",
  "order-id": "Order ID",
  "address": "Address",
  "state": "State",
  "city": "City",
  "lender": "Lender",
  "transaction-type": "Transaction",
  "type": "Type",
  "closing-date": "Closing Date",
  "licenses": "licenses",
  "create-order-leme": "Please, select the configuration that you need to this contract.",
  "no-orders-yet": "No orders yet",
  "please-create-order": "please, create a new order to start",
  "not-orders-open": "No open orders yet",
  "date-and-config": "Date & Config",
  "amounts": "Amounts",
  "property-information": "Property Information",
  "legal-description": "Legal Description",
  "subdivisions": "Subdivisions",
  "survey": "Survey",
  "attorney": "Attorney",
  "spouse": "Spouse",
  "property-description": "Property Legal Description",
  "acceptance-date": "Acceptance Date",
  "disbursement-date": "Disbursement Date",
  "purchase-price": "Purchase Price",
  "load-amount": "Loan Amount",
  "open": "Open",
  "add-new-employee": "Add New Employee",
  "create-associate-modal-create-associate": "Create New Employee",
  "apt-suite-etc": "apt, suite, stc…",
  "subdivision": "subdivision",
  "section": "section",
  "block": "block",
  "lot": "lot",
  "township": "Township",
  "range": "range",
  "complete-all-fields": "Please complete all the required fields and save your data",
  "property-type": "property type",
  "municipal-jurisdiction": "municipal jurisdiction",
  "parcel": "parcel",
  "add-parcel": "add parcel",
  "corporation": "Corporation",
  "limit-liability-company": "Limit Liability Company",
  "estate": "Estate",
  "trust": "Trust",
  "partnertship": "Partnership",
  "guardianship": "Guardianship",
  "settlement-statement": "Settlement Statement",
  "order-menu": "Order Menu",
  "parties-involved": "Parties Involved",
  "openedBy": "Opened By",
  "not-defined-yet":"Not Defined Yet",
  "purchase":"Purchase",
  "refinance":"Refinance",
  "heloc":"HELOC",
  "questions-and-answers": "Questions & Answers",
  "narrative": "Narrative",
  "orders-from": "Orders from ",
  "funding-date":"Funding Date",
  "please-select-order":"Please select an agency in your profile before creating a new order",
  "information-from-document":"Information collected from the document",
  "please-check-before":"Please review before creating the order. You can make changes later to this order.",
  "closed": "Closed",
  "hold": "On Hold",
  "cancelled": "Canceled",
  "table": "Table",
  "map": "Map",
  "view": "View",
  "propertyLabel": "Property",
  "kindLabel": "Kind",
  "typeLabel": "Type",
  "perDiemLabel": "Per Diem",
  "amountLabel": "Amount",
  "propertiesLabel": "Properties",
  "kindToChangeLabel": "Kind to Change",
  "newKindLabel": "New Kind",
  "descriptionLabel": "Description",
  "partyLabel": "Party",
  "signerLabel": "Signer",
  "startLabel": "Start",
  "endLabel": "End",
  "selectPartyLabel": "Select the party",
  "selectDocumentLabel": "Select Document",
  "criticalLabel": "Critical",
  "resolvedLabel": "Resolved",
  "commentsLabel": "Comments",
  "totalLabel": "Total",
  "briefLegalDescriptionLabel": "Brief Legal Description",
  "hideTaxLabel": "Hide Tax",
  "selectPayeePayerTitle": "Select Payee(s) and Payer(s)",
  "payeeLabel": "Payee",
  "payerLabel": "Payer",
  "expectedPaymentLabel": "Expected Payment",
  "editEntryButton": "Edit Entry",
  "deleteEntryButton": "Delete Entry",
  "changePayeesButton": "Change Payee(s)",
  "changePayersButton": "Change Payer(s)",
  "entryActionsLabel": "Entry actions",
  "associationDeletedMessage": "Association Deleted",
  "deletingMessage": "Deleting",
  "chargesUpdatedMessage": "Charges Updated",
  "updatingMessage": "Updating...",
  "notDefinedYetLabel": "Not defined Yet",
  "chargesTitle": "Charges",
  "tutorialTooltip": "Tutorial",
  "deleteChargeTitle": "Delete Charge",
  "deleteChargeConfirmation": "Are you sure you want to delete the charge with the description \"{{description}}\"? \nThis action cannot be undone, and all associated information will be lost.",
  "deleteChargeGenericConfirmation": "Are you sure you want to delete this charge? This action cannot be undone, and all associated information will be lost.",
  "confirmButton": "Confirm",
  "payeesLabel": "Payees",
  "payersLabel": "Payers",
  "taxesLabel": "Taxes",
  "atClosingLabel": "At Closing",
  "beforeClosingLabel": "Before Closing",
  "deleteDocumentTooltip": "Delete document",
  "editDocumentTooltip": "Edit document",
  "editPremiumLineButton": "Edit premium line in policy information",
  "paidByBorrowerLabel": "Paid By Borrower",
  "paidBySellerLabel": "Paid By Seller",
  "orderTab": "Order",
  "informationTab": "Contact Information",
  "changeContactKindsButton": "Change roles",
  "optionsTitle": "Options",
  "relationsTitle": "Relations",
  "byRoleTab": "By Role",
  "byNameTab": "By Name",
  "othersTab": "Other Parties",
  "willHaveLabel": "Will Have",
  "asLabel": "As",
  "selectNewKindTitle": "Select a New Kind to Replace the Current One",
  "partyNotInvolvedTitle": "Party not involved",
  "partyNotInvolvedMessage": "You are not involved in the order, this can be changed in the Parties screen.",
  "goToPartiesButton": "Go to Parties",
  "partiesLabel": "Parties",
  "attendeesLabel": "Attendees",
   "receptionsTitle": "Receptions",
   "textTab": "Text",
   "htmlTab": "HTML",
   "rawMessageTitle": "Raw message",
   "noReceptionInfo": "No reception information available",
   "orderNotesTitle": "Order Notes",
   "newNoteButton": "New Note",
   "newUpdateTitle": "New Update",
   "newNoteTitle": "New Note",
   "closeButton": "Close",
   "acceptButton": "Accept",
   "deleteNoteTitle": "Are you sure you want to delete this Note?",
   "deleteNoteSubtitle": "This action will permanently delete this note and cannot be undone. Do you want to proceed?",
   "deleteNoteCancelButton": "No, Keep Note",
   "deleteNoteConfirmButton": "Yes, Delete Note",
   "deleteNoteAria": "Delete note",
   "editNoteAria": "Edit note",
   "readMore": "Read more",
   "readLess": "Show less",
   "notesLoadingLabel": "Loading notes...",
   "noNotesTitle": "No notes yet",
   "noNotesMessage": "No notes have been created for this order yet. Create a new note to get started.",
  "actionsLabel": "Actions",
  "noLoansMessage": "There are no loans added yet",
  "daysPerYear360Label": "360 days per year",
  "daysPerYear365Label": "365 days per year",
  "daysPerYear366Label": "366 days per year",
  "prorationDateWarningMessage": "Proration Date is not in the range of Period Start Date and Period End Date",
  "periodStartDateLabel": "Period Start Date",
  "periodEndDateLabel": "Period End Date",
  "createProrationTitle": "Create Proration",
  "installmentOption": "Installment",
  "perDiemOption": "Per Diem",
  "basicOption": "Basic",
  "taxOption": "Tax",
  "createButton": "Create",
  "noPropertyMessage": "No property yet.",
  "goToProperties": "Go to Properties",
  "rateLabelInterest": "Rate",
  "indexNameLabel": "Index Name",
  "marginLabel": "Margin",
  "feeLabel": "Fee",
  "periodStartLabel": "Period Start",
  "periodEndLabel": "Period End",
  "changeDateLabel": "Change Date",
  "changeMinLabel": "Change Min",
  "changeMaxLabel": "Change Max",
  "monthsLabel": "Months",
  "rateMinLabel": "Rate Min",
  "rateMaxLabel": "Rate Max",
  "gracePeriodDaysLabel": "Grace Period Days",
  "decimalsLabel": "Decimals",
  "createLinkToEntryTitle": "Create Link to entry",
  "selectEntryLabel": "Select entry",
  "selectAssociationLabel": "Select association",
  "createLinkButton": "Create a Link",
  "selectColumnToFilterLabel": "Select Column to filter",
  "selectTypeOfFilterLabel": "Select Type of Filter",
  "searchLabel": "Search",
  "applyFilterButton": "Apply filter",
  "clearResultsButton": "Clear Results",
  "beforeClosingHeader": "Before Closing",
  "atClosingHeader": "At Closing",
  "paymentIdHeader": "Payment ID",
  "accountedByHeader": "Accounted By",
  "numberHeader": "No.",
  "authorizationsLabel": "Authorizations",
  "searchMembersPlaceholder": "Search members...",
  "viewChainButton": "View Chain",
  "loanFundingTitle": "Loan Funding",
  "loanAmountTitle": "Loan Amount",
  "netFundedTitle": "Net Funded",
  "lenderCreditsTitle": "Lender Credits",
  "paidByOthersTitle": "Paid By Others",
  "lenderChargesTitle": "Lender Charges",
  "aggregateAdjustmentTitle": "Aggregate Adjustment",
  "totalDebitAmountTitle": "Total Debit Amount",
  "totalCreditAmountTitle": "Total Credit Amount",
  "totalBalanceTitle": "Total balance",
  "balancedLabel": "Balanced",
  "overdisbursedLabel": "Overdisbursed",
  "underfundedLabel": "Underfunded",
  "cashOnlyTooltip": "The cash-only value will now be automatically determined based on whether loans are present in the order.",
  "cashOnlyOrderMessage": "This is a cash only order",
  "notCashOnlyOrderMessage": "This is not a cash only order",
  "noDataFoundMessage": "No data found",
  "goToPropertiesButton": "Go to Properties",
  "percentLabel": "Percent",
  "accountingBalancesTitle": "Accounting balances",
  "order-information": "Order Information",
  "dates-information": "Dates Information",
  "addendums-k": "Addendums K",
  "addendums-m": "Addendums M",
  "addendums-l": "Addendums L",
  "addendums-n": "Addendums N",
  "actual": "Actual",
  "disclosed": "Disclosed",
  "order-updated": "Order Updated",
  "updating": "Updating...",
  "note-by": "by {{name}}",
  "note-on": "on {{date}}",
  "orderPartiesListTitle": "Order Parties List",
  "parcelIdTitle": "{{parcel}} ID",
  "memberKindOn": "{{kind}} on {{name}}",
  "noMortgageMessage": "There are no mortgage payoffs added yet",
  "prorated-amount": "Prorated Amount",
  "proratedAmountWarningMessage": "Modifying the prorated amount will change the predefined calculations.",
  "ownership": "Ownership",
  "current-owners": "Current Owner(s)",
  "new-owners": "New Owner(s)",
  "split-current-owners": "Split among current owner(s)",
  "split-new-owners": "Split among new owner(s)"
}
